
import { useDispatch, useSelector } from 'react-redux';
import { useAdminSlice } from '../slice';
import { selectSelectedSessionIsdToView } from '../slice/selectors';

export default function useSingleSessionViewHandler() {
  const dispatch = useDispatch();
  const { actions } = useAdminSlice();
  const selectedSessionIsdToView = useSelector(selectSelectedSessionIsdToView);
  const setSelectedSessionIsdToView = (sessionId: string | null) => {
    dispatch(actions.setSelectedSessionIsdToView(sessionId));
  };
  return { selectedSessionIsdToView, setSelectedSessionIsdToView };
}
